"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStarRatingSlots = exports.default = exports.StarRating = void 0;
var _icons = require("@ori-ui/icons");
var _base = require("@ori-ui/mui-bundle/base");
var _material = require("@ori-ui/mui-bundle/material");
var _clsx = _interopRequireDefault(require("clsx"));
var _react = require("react");
var _starRatingClasses = _interopRequireWildcard(require("./starRatingClasses"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Helper function to round value to one decimal place if necessary.
 * Normal round function rounds to decimal value even if its not necessary.
 * @param num value to be rounded
 * @returns Special rounded value only if needed. 10.4444 => 10.4; 10 => 10
 */const roundUtil = (num, decimalPlaces = 1) => {
  const baseNumber = Number(`${num}e+${decimalPlaces}`);
  return +`${Math.round(baseNumber)}e-${decimalPlaces}`;
};
const getStarRatingSlots = _ => ({
  root: ['root'],
  star: ['star'],
  textRating: ['textRating'],
  emptyStar: ['emptyStar'],
  fullStar: ['fullStar'],
  halfStar: ['halfStar']
});
exports.getStarRatingSlots = getStarRatingSlots;
const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = getStarRatingSlots(ownerState);
  return (0, _base.unstable_composeClasses)(slots, _starRatingClasses.getStarRatingUtilityClass, classes);
};
const StarRatingRoot = (0, _material.styled)('span', {
  name: 'MuiOriStarRating',
  slot: 'Root',
  overridesResolver: (_, styles) => [styles.root, {
    [`.${_starRatingClasses.default.textRating}`]: styles.textRating
  }]
})(({
  theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '5px',
  [`.${_starRatingClasses.default.textRating}`]: {
    fontSize: '75%',
    marginLeft: '5px',
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.grey['700']
  }
}));
const StarHalfWrap = (0, _material.styled)('div', {
  name: 'MuiOriStarRating',
  slot: 'HalfStarWrap'
})({
  position: 'relative',
  display: 'flex'
});
const StyledStarIcon = (0, _material.styled)(_icons.FavouriteFilled, {
  name: 'MuiOriStarRating',
  slot: 'Star',
  shouldForwardProp: prop => prop !== 'starPercentageWidth',
  overridesResolver: ({
    ownerState: {
      starType
    }
  }, styles) => [styles.star, styles[`${starType}Star`]]
})(({
  theme,
  ownerState: {
    starType,
    starPercentageWidth
  }
}) => ({
  fontSize: '1.46em',
  // To get rid of mui icon spaces in icons
  margin: '0 -4px',
  ...(starType === 'empty' && {
    color: theme.palette.grey['200']
  }),
  ...(starType === 'half' && {
    position: 'absolute',
    left: 0,
    top: 0,
    // Star is rendered as a whole, we only show part of it. For this we use clip-path css property and rotate after clipping.
    // Clipping value is not exactly percentage value - its "100% - somePercentageValue%"
    clipPath: `inset(0 0 0 ${100 - (starPercentageWidth ?? 50)}%)`,
    transform: 'rotateY(180deg)',
    zIndex: 1
  }),
  ...((starType === 'half' || starType === 'full') && {
    color: theme.palette.default.dark
  })
}));
const StarRatingItem = /*#__PURE__*/(0, _react.memo)(props => /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledStarIcon, {
  ownerState: props,
  "data-star-type": props.starType,
  className: props.className
}));
const StarRatingText = /*#__PURE__*/(0, _react.memo)(({
  formattedValue,
  showTextRating,
  showVotes,
  votes
}) => {
  if (showVotes) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      className: _starRatingClasses.default.textRating,
      children: ["(", votes, ")"]
    });
  } else if (showTextRating) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      className: _starRatingClasses.default.textRating,
      children: ["(", formattedValue, ")"]
    });
  }
  return null;
});
const StarRating = exports.StarRating = /*#__PURE__*/(0, _react.forwardRef)((inProps, ref) => {
  const props = (0, _material.useThemeProps)({
    props: inProps,
    name: 'MuiOriStarRating'
  });
  const {
    max,
    value,
    showTextRating = false,
    showVotes = false,
    votes,
    precise = false,
    component = 'div',
    className,
    ...rest
  } = props;
  const stars = (0, _react.useMemo)(() => Array.from({
    length: max
  }).map((_, index) => index).map(index => {
    let result = value - index;
    let halfStarSize = 0;
    const halfStarCeiling = precise ? 0.9 : 0.5;
    let starType = 'empty';
    if (!precise) {
      // we round to closest 0.5, because we only want 0.5 or full numbers
      result = Math.round(result / 0.5) * 0.5;
    }
    if (result > 0) {
      if (result <= halfStarCeiling) {
        starType = 'half';
      } else {
        starType = 'full';
      }
    }
    if (starType === 'half') {
      halfStarSize = 100 * result / 1;
    }
    return {
      starId: index,
      starType,
      halfStarSize
    };
  }), [max, value, precise]);
  const classes = useUtilityClasses(props);
  const formattedValue = (0, _react.useMemo)(() => roundUtil(value), [value]);
  const constructStarClassName = (0, _react.useCallback)(starType => (0, _clsx.default)(classes[`${starType}Star`], classes.star), [classes]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StarRatingRoot, {
    ref: ref,
    as: component,
    title: `${formattedValue}/${max} ★`,
    className: (0, _clsx.default)(classes.root, className),
    ownerState: props,
    ...rest,
    children: [stars.map(({
      starType,
      halfStarSize,
      starId
    }) => {
      const starClassName = constructStarClassName(starType);
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
        children: [(starType === 'full' || starType === 'empty') && /*#__PURE__*/(0, _jsxRuntime.jsx)(StarRatingItem, {
          className: starClassName,
          starType: starType
        }), starType === 'half' && /*#__PURE__*/(0, _jsxRuntime.jsxs)(StarHalfWrap, {
          ownerState: props,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StarRatingItem, {
            className: starClassName,
            starPercentageWidth: halfStarSize,
            starType: starType
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StarRatingItem, {
            className: constructStarClassName('empty'),
            starType: "empty"
          })]
        })]
      }, starId);
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StarRatingText, {
      showVotes: showVotes,
      votes: votes,
      showTextRating: showTextRating,
      formattedValue: formattedValue
    })]
  });
});
var _default = exports.default = StarRating;
//# sourceMappingURL=StarRating.js.map